import { render, staticRenderFns } from "./comment_detail.vue?vue&type=template&id=d78720d4&scoped=true&"
import script from "./comment_detail.vue?vue&type=script&lang=js&"
export * from "./comment_detail.vue?vue&type=script&lang=js&"
import style0 from "./comment_detail.vue?vue&type=style&index=0&id=d78720d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d78720d4",
  null
  
)

export default component.exports